import { PiFile, PiImage, PiVideo, PiFileAudio } from 'react-icons/pi';
import { WhatsAppMediaType } from '../../../utils/whatsapp/media.util';
import { useImagePreview } from '../../../hooks/message-box/whatsapp/media-upload/image-preview';
import type { FilePreviewThumbnailProps } from '../../../types/whatsapp/file-preview.types';

/** Keeps image preview/fallback behavior inside a bounded attachment thumbnail. */
export const FilePreviewThumbnail = ({
  file,
  mediaType,
}: FilePreviewThumbnailProps) => {
  const {
    preview,
    previewError,
    imageLoaded,
    handleImageLoad,
    handleImageError,
  } = useImagePreview(file, mediaType);
  const Icon =
    mediaType === WhatsAppMediaType.IMAGE
      ? PiImage
      : mediaType === WhatsAppMediaType.VIDEO
        ? PiVideo
        : mediaType === WhatsAppMediaType.AUDIO
          ? PiFileAudio
          : PiFile;

  return (
    <div className="relative flex h-10 w-10 [@container(max-height:280px)]:h-8 [@container(max-height:280px)]:w-8 shrink-0 items-center justify-center overflow-hidden rounded-md bg-neutral-100 text-neutral-500">
      <Icon className="h-5 w-5" aria-hidden="true" />
      {mediaType === WhatsAppMediaType.IMAGE && preview && !previewError && (
        <img
          src={preview}
          alt={file.name}
          onLoad={handleImageLoad}
          onError={handleImageError}
          className={`absolute inset-0 h-full w-full object-cover ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
        />
      )}
    </div>
  );
};
